import React, { useState, Fragment, useEffect, createContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { cambioImagen } from "../../Slicersreducers";
import ReCAPTCHA from "react-google-recaptcha";
import classnames from "classnames";
import axiosInstance from "helpers/axiosInstance";
import icon_cliente from "assets/img/icons/icono-cliente.png";
import icon_supervisor from "assets/img/icons/icono-supervisor.png";
import IconTid from "../../assets/img/icons/Icono-Tipo-de-documento-Gris.png";
import IconNid from "../../assets/img/icons/Icono-Numero-documento-Gris.png";
import {
  Card,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  Modal,
  Badge,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Table,
  UncontrolledTooltip,
  Alert,
} from "reactstrap";
import { event } from "jquery";
import { useRef } from "react";

const UsuariosExternos = (props) => {
  const [imagen, setImagen] = useState(icon_cliente);
  const [imagenSuper, setImagenSuper] = useState(icon_supervisor);
  const [color, setColor] = useState("text-gray-dark");
  const [colorAutoriza, setColorAutoriza] = useState("text-gray-dark");

  const [tidnidpass, settidnidpass] = useState({
    tid: 3,
    nid: "",
    email: "",
    password: "",
  });
  const [nid, setNid] = useState("");
  const [numDocUser, SetNumDocUser] = useState("");
  const [numVerEnt, SetNumVerEnt] = useState("");
  const [isSupervisorUser, setIsSupervisorUser] = useState();
  const [checkSupervisor, setCheckSupervisor] = useState(false);
  const [hasNid, setHasNid] = useState(false);
  const [tidelec, settidelec] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [typesDocument, setTypesDocument] = useState("1");
  const [captchaValido, setCaptchaValido] = useState(false);
  const [listAlert, setListAlert] = useState([]);

  const mostrarFoto = useSelector((state) => state.miga.mostrarImage);

  var createReactClass = require("create-react-class");
  const dispatch = useDispatch();

  const handleChangeID = (event) => {
    settidnidpass({ ...tidnidpass, nid: event.target.value });
    console.log("esta editando");
    setNid(event.target.value);
    console.log(nid);
    setHasNid(event.target.value.trim() != "");
  };

  const handleChangeNumDocUser = (event) => {
    SetNumDocUser(event.target.value);
    console.log(numDocUser);
  };
  const handleChangeNumVerEnt = (event) => {
    SetNumVerEnt(event.target.value);
    console.log(numVerEnt);
  };

  const captcha = useRef(null);

  const onChange = () => {
    if (captcha.current.getValue) {
      console.log("el usuario no es un robot");
      setCaptchaValido(true);
    }
  };

  async function getIsSupervisor(type) {
    if (type === "N") {
      setColor("text-green");
      setColorAutoriza("text-gray-dark");
    } else {
      setColor("text-gray-dark");
      setColorAutoriza("text-green");
    }
    await setIsSupervisorUser(type);
  }

  const CheckUser = async () => {
    const request = await axiosInstance()
      .get(
        "/WSGYG39B/api/Register/Consulta/" +
          isSupervisorUser +
          "/" +
          typesDocument +
          "/" +
          numDocUser +
          "/" +
          3 +
          "/" +
          nid
      )
      .catch((err) => {
        props.userExist(false);
        setListAlert(
          err.response.data.errors.map((o) => ({
            ...o,
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle",
          }))
        );
        return "err";
      });
    if (request != "err") {
      console.log("respuesta del Api");
      console.log(request.data);
      props.userExist(true);
      props.data(request.data);
      dispatch(cambioImagen(false));
    }
  };
  function getTypeDocument(event) {
    setTypesDocument(event.target.value);
    console.log(event.target.value);
    switch (event.target.value) {
      case "1":
        settidelec([true, false, false, false, false, false, false]);

        break;
      case "2":
        settidelec([false, true, false, false, false, false, false]);

        break;
      case "3":
        settidelec([false, false, true, false, false, false, false]);

        break;
      case "5":
        settidelec([false, false, false, true, false, false, false]);

        break;
      case "6":
        settidelec([false, false, false, false, true, false, false]);

        break;
      case "8":
        settidelec([false, false, false, false, false, true, false]);

        break;
      case "9":
        settidelec([false, false, false, false, false, false, true]);
        break;
    }
  }
  const deleteAlert = (alert) => {
    console.log("elimina alerta");
    console.log(listAlert);
    setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
  };

  var Alerts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <div class={item.type} role="alert">
              <button
                type="button"
                class="close"
                aria-label="Close"
                onClick={() => deleteAlert(item)}
              >
                <span aria-hidden="true">×</span>
              </button>
              <span className="alert-inner--icon mr-3">
                <i className={item.icon} />
              </span>{" "}
              <span class="alert-inner--text">{item.description}</span>
            </div>
          );
        });
      }
      return <div className="toast-bottom-right">{newsTemplate}</div>;
    },
  });

  return (
    <Fragment>
      <div className="header pb-4 pt-2 ml-1 mr-1">
        <Container style={{ width: "70%" }} fluid>
          <div>
            <div
              style={{
                width: "100%",
                zIndex: "10",
                display: "flex",
                justifyContent: "flex-start",
                marginRight: "1px",
              }}
            >
              <div
                style={{
                  width: "90%",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "5px",
                }}
              >
                <h1
                  className="h1santander"
                  style={{
                    fontSize: "32px",
                    margin: "16px",
                    "font-weight": "bold",
                    "line-height": 1 + "em",
                    width: "480px",
                  }}
                >
                  Sucursal Virtual IDEA
                </h1>
                <div style={{ display: "flex", height: "50px" }}>
                  <img
                    className="ml-0 mt-3"
                    src={
                      require("../../assets/img/icons/Flecha Abajo-Verde-blanca.png")
                        .default
                    }
                  />
                  <a
                    role="button"
                    className="h6 mt-3 mb-0 ml-0 text-green "
                    href="auth/cambioCotraseña"
                  >
                    {"Regresar a inicio"}
                  </a>
                </div>
              </div>
            </div>
            <div className="header-body mb-1">
              <p
                style={{
                  marginBottom: "16px",
                  marginLeft: "16px",
                  marginTop: "16px",
                  "line-height": 1 + "em",
                }}
              >
                ¿El usuario que desea registrar es?
              </p>
              <Nav
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "40px",
                }}
                className="flex-column flex-md-row ml-6"
                id="tabs-icons-text"
                pills
                role="tablist"
              >
                <NavItem>
                  <NavLink
                    style={{
                      "padding-top": 0 + "rem",
                      width: 110 + "px",
                      height: 90 + "px",
                    }}
                    //aria-selected={tabs === 1}
                    className={classnames(
                      "card-body ml-1 mb-0 pb-0 mb-xl-0 shadow h-100",
                      {
                        active: isSupervisorUser === "N",
                      }
                    )}
                    onClick={() => {
                      getIsSupervisor("N");
                      setCheckSupervisor(true);
                    }}
                    href="#Cliente"
                    role="tab"
                  >
                    <Row
                      className="justify-content-center "
                      style={{ padding: 0.5 + "rem", height: "45%" }}
                    >
                      <div
                        className="icon icon-shape mt-0 mb-0 pb-0"
                        style={{ padding: 0 + "rem" }}
                      >
                        <img
                          className="my-header-image mt-1 mb-1 pt-0"
                          style={{ height: "50px" }}
                          src={imagen}
                        />
                      </div>
                    </Row>
                    <Row
                      className={classnames(
                        "justify-content-center mt-0 pb-0",
                        color
                      )}
                    >
                      <p
                        className="mt-1 mb-0 pt-1 text-bold"
                        style={{
                          fontSize: 14 + "px",
                          width: 105 + "px",
                          textAlign: "center",
                          "line-height": 1.25 + "em",
                          marginTop: 2 + "px",
                        }}
                      >
                        Cliente
                      </p>
                    </Row>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{
                      "padding-top": 0 + "rem",
                      width: 110 + "px",
                      height: 90 + "px",
                    }}
                    //aria-selected={tabs === 2}

                    className={classnames(
                      "card-body ml-1 mb-0 pb-0 mb-xl-0 shadow h-100",
                      {
                        active: isSupervisorUser === "S",
                      }
                    )}
                    onClick={() => {
                      getIsSupervisor("S");
                      setCheckSupervisor(true);
                    }}
                    href="#Supervisor"
                    role="tab"
                  >
                    <Row
                      className="justify-content-center "
                      style={{ padding: 0.5 + "rem", height: "45%" }}
                    >
                      <div
                        className="icon icon-shape mt-0 mb-0 pb-0"
                        style={{ padding: 0 + "rem" }}
                      >
                        <img
                          className="my-header-image mt-1 mb-1 pt-0"
                          style={{ height: "50px" }}
                          src={imagenSuper}
                        />
                      </div>
                    </Row>
                    <Row
                      className={classnames(
                        "justify-content-center mt-0 pb-0",
                        colorAutoriza
                      )}
                    >
                      <p
                        className="mt-1 mb-0 pt-1 text-bold"
                        style={{
                          fontSize: 14 + "px",
                          width: 105 + "px",
                          textAlign: "center",
                          "line-height": 1.25 + "em",
                          marginTop: 2 + "px",
                        }}
                      >
                        Supervisor
                      </p>
                    </Row>
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <p
              style={{
                marginTop: "16px",
                marginBottom: "7px",
                marginLeft: "16px",
                "line-height": 1.25 + "em",
                width: "400px",
              }}
            >
              Por favor digite los datos del usuario que desea registrar
            </p>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                  width: "185px",
                }}
              >
                <select
                  onChange={getTypeDocument}
                  placeholder="Tipo de documento"
                  style={{ border: "none", width: "100%", fontSize: "14px" }}
                >
                  <option value="1" selected={tidelec[0]}>
                    Cédula de Ciudadanía
                  </option>
                  <option value="2" selected={tidelec[1]}>
                    Tarjeta de Identidad
                  </option>
                  <option value="3" selected={tidelec[2]}>
                    NIT
                  </option>
                  <option value="5" selected={tidelec[3]}>
                    Pasaporte
                  </option>
                  <option value="6" selected={tidelec[4]}>
                    Carnet Diplomático
                  </option>
                  <option value="8" selected={tidelec[5]}>
                    Fideicomiso
                  </option>
                  <option value="9" selected={tidelec[6]}>
                    Registro Civil de Nacimiento
                  </option>
                </select>
                <img style={{ height: "12px" }} src={IconTid}></img>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                  width: "185px",
                }}
              >
                <input
                  required
                  maxLength={10}
                  pattern="\d*"
                  onChange={handleChangeNumDocUser}
                  value={numDocUser}
                  style={{
                    fontSize: "14px",
                    border: "none",
                    width: "250px",
                    height: "25px",
                    padding: "0px 0px 0px 5px",
                    margin: "0px 0px 0px 0px",
                  }}
                  placeholder="Número de documento"
                />
                <img style={{ height: "12px" }} src={IconNid} />
              </div>
            </div>
            <p
              style={{
                marginTop: "16px",
                marginBottom: "7px",
                marginLeft: "16px",
                "line-height": 1.25 + "em",
                width: "400px",
              }}
            >
              Digite por favor el NIT y el número de verificación de la entidad
              a la que pertenece
            </p>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                  width: "185px",
                }}
              >
                <input
                  required
                  pattern="\d*"
                  maxLength={17}
                  onChange={handleChangeID}
                  value={nid}
                  style={{
                    fontSize: "14px",
                    border: "none",
                    width: "250px",
                    height: "25px",
                    padding: "0px 0px 0px 5px",
                    margin: "0px 0px 0px 0px",
                  }}
                  placeholder="Número de NIT"
                />
                <img style={{ height: "12px" }} src={IconTid}></img>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "3px",
                  borderTop: "#DFE4E1 1px solid",
                  borderLeft: "#DFE4E1 1px solid",
                  borderRight: "#DFE4E1 1px solid",
                  borderBottom: "#767676 1px solid",
                  padding: "4px 8px 4px 4px",
                  borderRadius: "5px 5px 0px 0px",
                  margin: "15px",
                  width: "185px",
                }}
              >
                <input
                  onChange={handleChangeNumVerEnt}
                  value={numVerEnt}
                  style={{
                    fontSize: "14px",
                    border: "none",
                    width: "250px",
                    height: "25px",
                    padding: "0px 0px 0px 5px",
                    margin: "0px 0px 0px 0px",
                  }}
                  placeholder="Dígito de verificación"
                />
                <img style={{ height: "12px" }} src={IconNid} />
              </div>
            </div>
          </div>

          <div className="recaptcha ml-6">
            <ReCAPTCHA
              ref={captcha}
              sitekey="6LcylQkpAAAAAI6niY5_YNM4_OlQQXLGNMmix7Re"
              onChange={onChange}
            />
          </div>
          <Button
            type="submit"
            style={{ width: "40%", border: "none" }}
            //isLoading={isLoading}
            onClick={() => {
              CheckUser();
            }}
            disabled={!(checkSupervisor && hasNid && captchaValido)}
            //href={"/admin/RegistroUsuarioExterno?nit=" + nid + "&tus=" + isSupervisorUser +"&tid=" + typesDocument + "&numDocUser=" + numDocUser + "&numVerEnt=" + numVerEnt}
            className="my-1 mt-2 btn bg-green text-white btn-block ml-8"
          >
            Continuar
          </Button>

          <Alerts data={listAlert}></Alerts>
        </Container>
      </div>
    </Fragment>
  );
};

export default UsuariosExternos;
